import React, { useState } from 'react';
import Styles from './styles.module.css';
import Icon from './../../image/schoolEntry/icon.png';
import Title from './../../image/schoolEntry/title.png';
import Logo from './../../image/schoolEntry/logo.png';
import { addDoc, collection, getFirestore } from "firebase/firestore";

const School: React.FC = () => {

  const [ name, setName ] = useState('');
  const [ company, setCompany ] = useState('');

  const [ alert, setAlert ] = useState(0);

  const [ finish, setFinish ] = useState(false);

  function confirmation() {
    if (company === '') {
      setAlert(1);
    } else if (name === '') {
      setAlert(2);
    } else {
      update();
    }
  }

  async function update() {

    const db = getFirestore();

    await addDoc(collection(db, "contacts"), {
      to: "oobayashi@memorii-works.com",
      company: company,
      name: name,
      tellPhone: "",
      text: "デモ画面 利用希望",
      time: new Date(),
    })
    .then(() => {
      setFinish(true);
    });

  }

  return (
    <>
    <div className={Styles.box}>

      <a href="https://memorii-works.com/" target="_blank" rel="noopener noreferrer">
        <img src={Icon} className={Styles.logo} />
      </a>

      <img src={Title} className={Styles.image} />
      <div style={{height: "30px"}}></div>
      <img src={Logo} className={Styles.image} />

      <div style={{height: "20px"}}></div>

      <div className={Styles.contact}>

        <h4>デモ画面 申請画面</h4>

        {finish ?
        <>
          <p className={Styles.done}>申請が完了いたしました。3営業日以内にご連絡させていただきます。</p>
        </>
        :
        <>
          <div className={Styles.contents_box}>
            <h3>学校名<span>*</span></h3>
            <input value={company} onChange={e => setCompany(e.target.value)} placeholder="〇〇専門学校" />
          </div>
          
          <p className={Styles.contents_alert} style={alert === 1 ? {display : 'block'} : {display : 'none'}}>※学校名を入力してください。</p>

          <div className={Styles.contents_box}>
            <h3>担当者名<span>*</span></h3>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="メモリ 太郎" />
          </div>

          <p className={Styles.contents_alert} style={alert === 2 ? {display : 'block'} : {display : 'none'}}>※担当者名を入力してください。</p>

          <button className={Styles.btn} onClick={() => confirmation()}>申請</button>
        </>}

      </div>

    </div>
    </>
  );
}

export default School;
